import {
  parseUrlSegments,
  type TextSegment,
} from "@/components/ui/text/url-segments";

export interface ChatMessageContentRootNode {
  id: "root";
  type: "root";
  children: ChatMessageContentInlineNode[];
}

export type ChatMessageContentInlineNode =
  | ChatMessageContentTextNode
  | ChatMessageContentLinkNode;

export interface ChatMessageContentTextNode {
  id: string;
  type: "text";
  value: string;
}

export interface ChatMessageContentLinkNode {
  id: string;
  type: "link";
  value: string;
  href: string;
}

export function parseChatMessageContent(
  text: string,
): ChatMessageContentRootNode {
  return {
    id: "root",
    type: "root",
    children: parseUrlSegments(text).map(toChatMessageContentNode),
  };
}

function toChatMessageContentNode(
  segment: TextSegment,
): ChatMessageContentInlineNode {
  if (segment.type === "text") {
    return {
      id: segment.id,
      type: "text",
      value: segment.value,
    };
  }

  return {
    id: segment.id,
    type: "link",
    value: segment.value,
    href: segment.href,
  };
}
